import "core-js/modules/web.dom.iterable";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import { getAction } from '@/api/manage';
export var ChangeColMixin = {
  data: function data() {
    return {
      indeterminate: false,
      checkAll: true,
      //   动态列数组
      options: [],
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      // 站点列
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        width: '200px',
        title: '站点',
        align: 'center'
      },
      cols: [{
        title: '监测时间',
        align: 'center',
        width: 150,
        dataIndex: 'dataTime',
        colName: 'data_time'
      }],

      /* 查询条件-请不要在queryParam中声明非字符串值的属性 */
      queryParam: {},

      /* 数据源 */
      dataSource: [],
      columns: [],
      allColumns: [],
      selectCol: [],
      isPagination: true,

      /* 分页参数 */
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: function showTotal(total, range) {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },

      /* 排序参数 */
      isorter: {// column: 'createTime',
        // order: 'desc',
      },

      /* table加载状态 */
      loading: false
    };
  },
  mounted: function mounted() {
    this.loadData();
  },
  methods: {
    // 水质标准
    renderStatus: function renderStatus(record) {
      var h = this.$createElement;

      if (record.currentStandard) {
        return h("span", {
          "class": "statusText",
          "style": 'background-color:' + record.currentStandard.color
        }, [record.currentStandard.title]);
      } else {
        return '';
      }
    },
    // 渲染列
    renderCol: function renderCol(code, text, record) {
      var h = this.$createElement;
      var data = record.dataCodeMap[code] || {
        value: ''
      };

      if (data.status == '2') {
        return h("span", {
          "class": "redText",
          "attrs": {
            "title": '原始数据： ' + data.raw
          }
        }, [data.value, h("a-icon", {
          "attrs": {
            "type": "arrow-down"
          },
          "style": "float:right"
        })]);
      } else if (data.status == '3') {
        return h("span", {
          "class": "redText",
          "attrs": {
            "title": '原始数据： ' + data.raw
          }
        }, [data.value, h("a-icon", {
          "attrs": {
            "type": "arrow-up"
          },
          "style": "float:right"
        })]);
      } else {
        return h("span", {
          "attrs": {
            "title": '原始数据： ' + data.raw
          }
        }, [data.value]);
      }
    },
    searchQuery: function searchQuery() {
      this.loadData(1);
    },
    // 动态列变化
    onChange: function onChange() {
      this.indeterminate = !!this.selectCol.length && this.selectCol.length < this.options.length;
      this.checkAll = this.selectCol.length === this.options.length;
      this.changeCol();
    },
    changeCol: function changeCol() {
      var _this = this;

      if (!this.columns.every(function (item) {
        return item.dataIndex != 'siteName';
      })) {
        this.columns = _toConsumableArray(this.cols);
        this.columns.splice(1, 0, this.siteColumn);
        this.selectCol.forEach(function (item, i) {
          _this.allColumns.forEach(function (element) {
            if (item == element.id) {
              _this.columns.push(element);
            }
          });
        });
      } else {
        this.columns = _toConsumableArray(this.cols);
        this.selectCol.forEach(function (item, i) {
          _this.allColumns.forEach(function (element) {
            if (item == element.id) {
              _this.columns.push(element);
            }
          });
        });
      }
    },
    // 全选/反选
    onCheckAllChange: function onCheckAllChange(e) {
      Object.assign(this, {
        selectCol: e.target.checked ? this.options.map(function (item) {
          return item.value;
        }) : [],
        indeterminate: false,
        checkAll: e.target.checked
      });
      this.changeCol();
    },
    //添加删除列，idx有值代表插入，无值代表删除
    spliceColumn: function spliceColumn(col, idx) {
      //debugger
      var tempColumn = this.columns.filter(function (item) {
        return item.dataIndex != col.dataIndex;
      }); //不允许存在dataIndex相同的列

      if (idx) {
        //插入索引位置
        if (tempColumn.length == this.columns.length) {
          //数组长度一样，说明不存在列，直接添加
          this.columns.splice(idx, 0, col);
        }
      } else {
        if (tempColumn.length != this.columns.length) {
          //数组长度不一样，说明存在列，需要删除
          this.columns = tempColumn;
        }
      }
    },
    handleTableChange: function handleTableChange(pagination, filters, sorter) {
      this.ipagination = pagination;
      this.loadData();
    },
    // 加载表格
    loadData: function loadData(arg) {
      var _this2 = this;

      this.loading = true;
      var that = this; // debugger

      if (arg === 1) {
        this.ipagination.current = 1;
      }

      if (this.isPagination) {
        this.queryParam.current = this.ipagination.current;
        this.queryParam.size = this.ipagination.pageSize;
        this.queryParam.column = 'data_time';
        this.queryParam.order = 'desc';
      }

      this.queryParam.st = window.sessionStorage.getItem('siteType');
      getAction(this.url, this.queryParam).then(function (res) {
        if (res.success) {
          that.allColumns = _toConsumableArray(that.cols);
          that.selectCol = [];
          that.options = [];

          if (_this2.isPagination) {
            that.dataSource = res.result.records;
            that.ipagination.total = res.result.total;
            res.result.factors.forEach(function (element) {
              that.options.push({
                label: element.title,
                value: element.id
              });
              that.selectCol.push(element.id);
              that.allColumns.push({
                id: element.id,
                title: element.title,
                align: 'center',
                width: 250,
                children: [{
                  title: element.unitName,
                  align: 'center',
                  width: 200,
                  dataIndex: element.code,
                  customRender: function customRender(text, record, index) {
                    return that.renderCol(element.code, text, record);
                  }
                }]
              });
            });
            that.columns = _toConsumableArray(that.allColumns);

            if (that.queryParam.type == '1') {
              that.spliceColumn(that.siteColumn);
            } else if (that.queryParam.type == '2') {
              that.spliceColumn(that.siteColumn, 1);
            }
          } else {
            that.dataSource = res.result.data;
            res.result.factors.forEach(function (element) {
              that.options.push({
                label: element.title,
                value: element.code
              });
              that.selectCol.push(element.code);
              that.allColumns.push({
                id: element.code,
                title: element.title,
                align: 'center',
                width: 250,
                children: [{
                  title: element.unitName,
                  align: 'center',
                  width: 200,
                  dataIndex: element.code,
                  customRender: function customRender(text, record, index) {
                    return that.renderCol(element.code, text, record);
                  }
                }]
              });
            });
            that.columns = _toConsumableArray(that.allColumns);
          }
        } else {
          _this2.$message.warning('系统异常=>' + res.message);
        }

        _this2.loading = false;
      });
    }
  }
};